import View from './view';

export const SocialSupportList = View;
